import { useEffect, useState } from "preact/hooks"

type DeviceType = "mobile" | "desktop"

export function useDeviceType(): DeviceType {
  const [deviceType, setDeviceType] = useState<DeviceType>(() =>
    (typeof window !== "undefined" && window.matchMedia("(min-width: 768px)").matches
      ? "desktop"
      : "mobile"),
  )

  useEffect(() => {
    if (typeof window === "undefined") return

    const mediaQuery = window.matchMedia("(min-width: 768px)")

    const handleChange = (e: MediaQueryListEvent) => {
      setDeviceType(e.matches ? "desktop" : "mobile")
    }

    mediaQuery.addEventListener("change", handleChange)

    return () => mediaQuery.removeEventListener("change", handleChange)
  }, [])

  return deviceType
}
